import { alpha, Box } from '@mui/material'
import type { BoxProps } from '@mui/system'
import { useIsDark } from '@xylabs/react-theme'
import type { FC } from 'react'
import React, { useMemo } from 'react'

const percentBackground = (percent: number) => `color-mix(in srgb, var(--mui-palette-background-default), transparent ${percent}%)`

const generateBackgroundGradientBox1Style = (dark: boolean) => ({
  background:
  `radial-gradient(circle 400px at 5% 800px, ${alpha(dark ? '#5D3FF2' : '#3420B0', 0.15)}, ${percentBackground(10)}),
    radial-gradient(circle 900px at -20% 1400px, ${alpha('#FF5BDC', 0.09)}, ${percentBackground(10)}),
    radial-gradient(circle 600px at 90% 2000px, ${alpha(dark ? '#5D3FF2' : '#3420B0', 0.2)}, ${percentBackground(20)}),
    radial-gradient(circle 600px at 50% 1800px, ${alpha(dark ? '#5D3FF2' : '#3420B0', 0.25)}, ${percentBackground(20)}),
    radial-gradient(circle 500px at 68% 1000px, ${alpha('#FF5BDC', 0.15)}, ${percentBackground(20)}),
    radial-gradient(circle 900px at 90% 3000px, ${alpha(dark ? '#5D3FF2' : '#3420B0', 0.25)}, ${percentBackground(20)}),
    radial-gradient(circle 300px at 99% 700px, ${alpha('#FF5BDC', 0.25)}, ${percentBackground(10)}), 
    radial-gradient(circle 400px at 5% 3100px, ${alpha(dark ? '#5D3FF2' : '#3420B0', 0.15)}, ${percentBackground(10)}),
    radial-gradient(circle 900px at -20% 4400px, ${alpha('#FF5BDC', 0.09)}, ${percentBackground(10)}),
    radial-gradient(circle 600px at 90% 5000px, ${alpha(dark ? '#5D3FF2' : '#3420B0', 0.2)}, ${percentBackground(20)}),
    radial-gradient(circle 600px at 50% 4800px, ${alpha(dark ? '#5D3FF2' : '#3420B0', 0.25)}, ${percentBackground(20)}),
    radial-gradient(circle 900px at 68% 3800px, ${alpha('#FF5BDC', 0.15)}, ${percentBackground(20)}),
    radial-gradient(circle 900px at 90% 6000px, ${alpha(dark ? '#5D3FF2' : '#3420B0', 0.25)}, ${percentBackground(20)}),
    radial-gradient(circle 300px at 95% 3300px, ${alpha('#FF5BDC', 0.25)}, ${percentBackground(10)})`,
})

export const BackgroundGradientBox1: FC<BoxProps> = ({ sx, ...props }) => {
  const dark = useIsDark()
  const sxAdditional = useMemo(() => {
    return generateBackgroundGradientBox1Style(dark)
  }, [dark])

  return <Box sx={{ ...sxAdditional, ...sx }} {...props} />
}
